module.exports = __webpack_public_path__ + "media/react/pages/essay_review/illustrated-avatars/2-878b6645855cb2f2c40e960e76898214.png";